var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95034 2.95015C3.16187 2.73862 3.50484 2.73862 3.71637 2.95015L10 9.2338L16.2837 2.95015C16.4952 2.73862 16.8382 2.73862 17.0497 2.95015C17.2612 3.16169 17.2612 3.50465 17.0497 3.71619L10.7661 9.99984L17.0497 16.2835C17.2612 16.495 17.2612 16.838 17.0497 17.0495C16.8382 17.2611 16.4952 17.2611 16.2837 17.0495L10 10.7659L3.71637 17.0495C3.50484 17.2611 3.16187 17.2611 2.95034 17.0495C2.7388 16.838 2.7388 16.495 2.95034 16.2835L9.23399 9.99984L2.95034 3.71619C2.7388 3.50465 2.7388 3.16169 2.95034 2.95015Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1965824aa2bcbdec3cf21ddb4bc3b22f.svg";
export { ForwardRef as ReactComponent };